import work1 from "../../assets/work1_1.png";
import work2 from "../../assets/work2.png";
import work3 from "../../assets/work3_3.png";
import work4 from "../../assets/work4_4.png";
import work5 from "../../assets/work5_5.png";
import work6 from "../../assets/work6.png";
import work7 from "../../assets/work7.png";
import work8 from "../../assets/work8.png";
import work9 from "../../assets/work9.png";

export const projectsData = [

    {
        id: 8,
        image: work8,
        title: "Food Recipe Generator",
        category: "Generative AI",
        link: "https://github.com/Hurry-sh/Recipe-Generator-Using-GenAI.git",
    },

    {
        id: 9,
        image: work9,
        title: "C3I Project",
        category: "Machine Learning",
        link: "https://github.com/Hurry-sh/C3I_Internship_Project",
    },

    {
        id: 2,
        image: work2,
        title: "CCNCS Project",
        category: "Machine Learning",
        link: "https://github.com/Hurry-sh/CCNCS-Project",
    },

    {
        id: 1,
        image: work1,
        title: "PESU Website",
        category: "Web-Design",
        link: "https://github.com/Hurry-sh/PESU-Website-Development",
    },


    {
        id: 3,
        image: work3,
        title: "Socket Programming",
        category: "Computer Networks",
        link: "https://github.com/Hurry-sh/Time-Server-Socket-Programming",
    },

    {
        id: 4,
        image: work4,
        title: "Image Classifier (Dog and Cat)",
        category: "Machine Learning",
        link:"https://github.com/Hurry-sh/CNN-Image-Classifier",
    },

    {
        id: 5,
        image: work5,
        title: "Hand Writing Recognition",
        category: "Machine Learning",
        link: "https://github.com/Hurry-sh/Hand-Writing-Recognition",
    },

    {
        id: 6,
        image: work6,
        title: "My Portfolio",
        category: "Web-Design",
        link: "https://github.com/Hurry-sh/Portfolio",
    },

    {
        id: 7,
        image: work7,
        title: "Distributed File Server",
        category: "Big Data",
        link: "https://github.com/Cloud-Computing-Big-Data/EC-Team-47-distributed-file-orchestration-and-synchronization",
    },

];

export const projectsNav = [
    {
        name: 'All',
    },

    {
        name: 'Web-Design',
    },

    {
        name: 'Miniproject',
    },

    {
        name: 'ML/DL',
    },
];